import React from 'react';
import type { EditWidgetRowProps, WidgetCommonProps } from '../hooks/integrations/externalIntegrationTypes';
import { Input } from '@upsales/components';
import WidgetFieldSetting from './helpers/WidgetFieldSetting';
import { useTranslation } from 'Components/Helpers/translate';
import './UiWidgetImage.scss';

export const EditUiWidgetImage = ({ row, onUpdate }: EditWidgetRowProps) => {
	const url = row.settings?.url || '';
	const { t } = useTranslation();

	const handleChange = (field: 'url') => (e: React.ChangeEvent<HTMLInputElement>) => {
		onUpdate({
			...row,
			settings: {
				...row.settings,
				[field]: e.target.value
			}
		});
	};

	return (
		<div className="UiWidget__imageEdit">
			<WidgetFieldSetting text={t('default.url')}>
				<Input value={url} onChange={handleChange('url')} />
			</WidgetFieldSetting>
		</div>
	);
};

const UiWidgetImage: React.FC<WidgetCommonProps> = ({ row }) => {
	const url = row.settings?.url || '';

	return (
		<div className="UiWidget__image">
			<img src={url} />
		</div>
	);
};

export default UiWidgetImage;
